/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_appsync_graphqlEndpoint": "https://mboetcn7ezcd5brb7pcyp6ximq.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-southeast-2:4f7ae984-9077-4a74-883d-43ea043d077f",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_qP5nV9BcB",
    "aws_user_pools_web_client_id": "33tupfgct9tce54qga16gkms09",
    "oauth": {
        "domain": "workflowfoundation52c9732a-52c9732a-nonprod.auth.ap-southeast-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://d311dcs9e5a2fw.cloudfront.net/",
        "redirectSignOut": "http://localhost:3000/,https://d311dcs9e5a2fw.cloudfront.net/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "workflowoundation-20230828101344-hostingbucket-nonprod",
    "aws_content_delivery_bucket_region": "ap-southeast-2",
    "aws_content_delivery_url": "https://d16shru875w3el.cloudfront.net",
    "aws_user_files_s3_bucket": "workflowfoundation93960343c661471dbf9ca875b837e102501-nonprod",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};


export default awsmobile;
